import { PluginFunc } from "dayjs";

const plugin: PluginFunc<never> = (_, dayjsClass, __) => {
  dayjsClass.prototype.localizedShortDate = function () {
    return this.toDate().toLocaleString(this.locale(), {
      weekday: "long",
      day: "numeric",
      month: "long",
    });
  };
};

declare module "dayjs" {
  interface Dayjs {
    localizedShortDate(): string;
  }
}

export default plugin;
